<template>
  <div id="ageGateContainer" class="fullscreen" v-show="hide">
    <div class="ag-container">
      <div v-if="isgerman">
        <h2 class="mb-20">Altersüberprüfung</h2>
        <p>
          Als eine der größten Premium-Biermarken Deutschlands tragen wir
          Verantwortung und setzen uns im Rahmen der gesetzlichen Bestimmungen für
          den verantwortungsbewussten Umgang mit alkoholhaltigen Getränken ein.
          Die folgenden Seiten enthalten Werbeinformationen zu alkoholischen
          Getränken.
        </p>
        <p>
          <strong>Bitte bestätigen Sie, dass Sie über 16 Jahre alt sind.</strong>
        </p>
        <p>Bitte geben Sie dazu Ihr Geburtsdatum ein.</p>
      </div>
      <div v-else>
        <h2 class="mb-20">Age Verification</h2>
        <p>
          As one of the largest premium beer brands in Germany, we take
          responsibility and are committed to promoting the responsible use of
          alcoholic beverages within the legal framework. The following pages
          contain advertising information for alcoholic beverages.
        </p>
        <p>
          <strong>Please confirm that you are over 16 years old.</strong>
        </p>
        <p>Please enter your date of birth.</p>
      </div>
      <form v-on:submit.prevent="onSubmit" id="ageGateForm">
        <div class="row flexbox f-c mb-20 mt-20 uk-form-row">
          <input aria-label="Tag" v-model="day" class="day form-control" name="day" id="day" maxlength="2"
            autocomplete="off" placeholder="DD" required />
          <input aria-label="Monat" v-model="month" class="month form-control" name="month" id="month" maxlength="2"
            autocomplete="off" placeholder="MM" required />
          <input aria-label="Jahr" v-model="year" class="year form-control" name="year" id="year" maxlength="4"
            autocomplete="off" placeholder="YYYY" required />
        </div>
        <div class="form-group mb-20">
          <button class="btn btn-primary" id="submitAgegate" type="submit">
            <span v-if="isgerman">Absenden</span>
            <span v-else>Submit</span>
          </button>
        </div>
      </form>
      <div id="ageGateError">
        <h2 v-if="isgerman" class="text-danger mb-20" v-show="error">
          Sie sind nicht alt genug.
        </h2>
        <h2 v-else class="text-danger mb-20" v-show="error">
          You are not old enough.
        </h2>
      </div>
      <div v-if="isgerman"><b>Bitte trinken Sie verantwortungsvoll!</b></div>
      <div v-else><b>Please drink responsibly!</b></div>
      <div class="dark" v-if="isgerman">
        <small class="dark">Mit dem Absenden dieses Formulars erklären Sie sich mit den
          <a href="/datenschutz/index.php">Nutzungsbedingungen und der Datenschutzerklärung</a>
          einverstanden.
        </small>
      </div>
      <div class="dark" v-else>
        <small class="dark">By submitting this form, you agree to the
          <a href="/datenschutz/index.php">Terms of Use and Privacy Policy</a>.
        </small>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  props: {
    isgerman: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      day: "",
      month: "",
      year: "",
      error: false,
      hide: false,
    };
  },
  mounted() {
    if (document.URL === "https://besucherzentrum.online/datenschutz/index.php")
      return;

    var hash = window.location.search;
    let isVerified = new URLSearchParams(hash).get("verification");

    if (isVerified) {
      localStorage.setItem("age", true);
    }

    let age = localStorage.getItem("age");
    if (!age || age !== "true") {
      this.hide = true;
    }
  },
  watch: {
    day(newItem) {
      let month = document.querySelector("#month");
      if (newItem.toString().length == 2) {
        month.focus();
        month.select();
      }
    },
    month(newItem) {
      let year = document.querySelector("#year");
      if (newItem.toString().length == 2) {
        year.focus();
        year.select();
      }
    },
    year(newItem) {
      if (newItem.toString().length != 4)
        return

      this.onSubmit();
    }
  },
  methods: {
    onSubmit() {
      axios
        .post("/api/agegate.php", {
          day: this.day,
          month: this.month,
          year: this.year,
        })
        .then((e) => {
          if (e.data.result === "ok") {
            localStorage.setItem("age", true);

            return (this.hide = false);
          }
          this.error = true;
        });
    },
  },
};
</script>

<style>
.mb-10 {
  margin-bottom: 2rem;
}

.mb-20 {
  margin-bottom: 4rem;
}

.mt-20 {
  margin-top: 4rem;
}

.f-c {
  justify-content: center;
}

.row.flexbox {
  display: flex;
}

.fullscreen .ag-container {
  width: 720px;
}

.fullscreen {
  font-size: 16px;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100vh;
  z-index: 1000;
  position: fixed;
  background: rgba(255, 255, 255, 0.5);
  overflow: auto;
}

.fullscreen .ag-container {
  padding: 20px 15px 0 15px;
  width: 90%;
  line-height: 1.4em;
  text-align: center;
  margin: 5% auto auto;
  background-color: whitesmoke;
  border: 1px solid white;
}

#ageGateForm.uk-form .form-control {
  background-color: white;
  color: black;
}

.fullscreen .ag-container input {
  margin: 0 5px;
  color: black;
  text-align: center;
  width: 100px;
}

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
  .fullscreen .ag-container {
    width: 720px;
  }
}
</style>
